<template lang="pug">
.popup-wrapper
    .new-customer-popup
        .exit-container
            .close(@click="closePopup" ) x
        .title Create a new Customer
        .input-container
            .top-row
                .first-name
                    .first-name-label First Name
                    input.first-name-input(v-model="firstName")
                .last-name
                    .last-name-label Last Name
                    input.last-name-input(v-model="lastName")
            .bottom-row
                .email
                    .email-label Email
                    input.email-input(v-model="email")
                .phone
                    .phone-label Phone
                    input.phone-input(v-model="phone")
        .button-container
            button.g-outline.create-customer-btn(@click="createAccount") Create New Customer
            span(v-if="error") {{error}}


</template>
<script lang="ts" setup>
import { Userspaces } from "@busy-human/k9-library";
import { useAuth } from '../store/auth';
import { ref } from 'vue';


type Props = {
    showPopup?: boolean
}
type Emits = {
    (e: 'update:showPoup', value:boolean):void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>();
const auth = useAuth();

const firstName = ref("")
const lastName = ref("")
const email = ref("")
const phone = ref("")
const error = ref("")


const closePopup = () =>{
    console.log("called!")
    emit('update:showPoup',false)
}

const createAccount = async() =>{
    try{
       let newUser = Userspaces.Defaults()
       newUser.email = email.value
       newUser.phone = phone.value
       newUser.name = {
           firstName:firstName.value,
           lastName: lastName.value,
           fullName: typeof newUser.name == "string" ? newUser.name : newUser.name.fullName,
       }
       const response = await auth.createUserAndResetPass(newUser)
       // console.log("RESP:",response)

       if(response.success){
           alert("Account Created.")
           closePopup()
       }
    }catch(e){
       console.error(e)
       if(typeof e === 'string')
           error.value = e
    }
}

</script>
<style lang="scss">
.popup-wrapper{
    left: 0;
    top: 0;
    z-index:10;
    position:fixed;
    background:rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;

    .new-customer-popup{
        border-radius:5px;
        width: 590px;
        height:311px;
        display: flex;
        align-items: center;
        flex-direction: column;
        background:white;

        .exit-container{
            font-size:28px;
            height:10%;
            width: 98%;
            text-align: right;
            .close{
                height:100%;
                &:hover{
                    cursor:pointer;
                }
            }
        }
        .title{
            display:flex;
            flex-direction:column;
            justify-content:flex-end;
            align-items: center;
            font-weight:bold;
            height: 8%;
            font-size: 32px;
            text-align: center;
        }
        .input-container{
            width:100%;
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height:65%;
            .top-row,.bottom-row{
                width:95%;
                height:35%;
                display:flex;
                justify-content: space-around;
                .first-name,.last-name,.email,.phone{
                    width:45%;
                    input{
                        height:28px;
                        width: 100%;
                        border-radius:10px;
                        border: 2px solid $color-red;
                    }
                }
            }
        }
        .button-container{
            display: flex;
            align-items: center;
            justify-content: center;
            height:21%;
        }
    }
}


</style>